import { Helmet } from "react-helmet";
import React from "react";

import {
  Navbar,
  Footer,
  Landing,
  About,
  Skills,
  Testimonials,
  Experience,
  Contacts,
  Projects,
  Services,
} from "../../components";
import { headerData } from "../../data/headerData";

const Main: React.FC = () => {
  return (
    <div>
      <Helmet>
        <title>{headerData.name} - Porfolio</title>
      </Helmet>

      <Navbar />
      <Landing />
      <About />
      <Skills />
      <Experience />
      <Projects />
      <Services />
      <Testimonials />
      <Contacts />
      <Footer />
    </div>
  );
};

export default Main;
